class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.leaveTimeout = null;
    this.desktopMedia = window.matchMedia('(min-width: 990px)');
    this.boundOnMouseEnter = this.onDesktopMouseEnter.bind(this);
    this.boundOnMouseLeave = this.onDesktopMouseLeave.bind(this);
    this.boundOnFocusIn = this.onDesktopFocusIn.bind(this);
    this.boundOnKeyDown = this.onKeyDown.bind(this);
  }

  connectedCallback() {
    this.setupDesktopHover();
  }

  setupDesktopHover() {
    if (!this.mainDetailsToggle) return;
    this.removeDesktopHover();
    if (!this.boundMediaChange) {
      this.boundMediaChange = () => {
        this.removeDesktopHover();
        if (this.desktopMedia.matches) this.addDesktopHover();
      };
      this.desktopMedia.addEventListener('change', this.boundMediaChange);
    }
    if (this.desktopMedia.matches) this.addDesktopHover();
  }

  addDesktopHover() {
    this.addEventListener('mouseenter', this.boundOnMouseEnter);
    this.addEventListener('mouseleave', this.boundOnMouseLeave);
    this.addEventListener('focusin', this.boundOnFocusIn);
    this.addEventListener('keydown', this.boundOnKeyDown);
  }

  removeDesktopHover() {
    this.removeEventListener('mouseenter', this.boundOnMouseEnter);
    this.removeEventListener('mouseleave', this.boundOnMouseLeave);
    this.removeEventListener('focusin', this.boundOnFocusIn);
    this.removeEventListener('keydown', this.boundOnKeyDown);
    if (this.leaveTimeout) clearTimeout(this.leaveTimeout);
  }

  onDesktopMouseEnter() {
    if (!this.desktopMedia.matches) return;
    if (this.leaveTimeout) {
      clearTimeout(this.leaveTimeout);
      this.leaveTimeout = null;
    }
    this.closeSiblings();
    this.open();
  }

  onDesktopMouseLeave() {
    if (!this.desktopMedia.matches) return;
    this.leaveTimeout = setTimeout(() => this.close(), 120);
  }

  onDesktopFocusIn() {
    if (!this.desktopMedia.matches) return;
    if (this.leaveTimeout) {
      clearTimeout(this.leaveTimeout);
      this.leaveTimeout = null;
    }
    this.closeSiblings();
    this.open();
  }

  onKeyDown(e) {
    if (e.key === 'Escape') {
      this.close();
    }
  }

  closeSiblings() {
    const menu = this.closest('.header__inline-menu');
    if (!menu) return;
    const siblings = menu.querySelectorAll('header-menu');
    siblings.forEach((el) => {
      if (el !== this && el.close) el.close();
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onToggle() {
    super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
